// mutations.js

export default {
    SET_AUTHENTICATED(state, isAuthenticated) {
        state.isAuthenticated = isAuthenticated;
    },
    SET_USER(state, user) {
        state.user = user;
    },

    setAccessToken(state, access_token) {
        state.access_token = access_token;
    },  
 
};
